import { GithubPermissions } from "../types";

export const GITHUB_PERMISSIONS_LEVELS = {
  Read: "Read-only",
  Write: "Read and write",
};

export const GITHUB_PERMISSIONS_NAMES = {
  [GithubPermissions.Administration]: "Administration",
  [GithubPermissions.Checks]: "Checks",
  [GithubPermissions.Statuses]: "Commit statuses",
  [GithubPermissions.Contents]: "Contents",
  [GithubPermissions.Deployments]: "Deployments",
  [GithubPermissions.Issues]: "Issues",
  [GithubPermissions.Members]: "Members",
  [GithubPermissions.Metadata]: "Metadata",
  [GithubPermissions.PullRequests]: "Pull requests",
  [GithubPermissions.Webhooks]: "Webhooks",
};

export const GITHUB_PERMISSIONS_DETAILS = {
  [GithubPermissions.Administration]: GITHUB_PERMISSIONS_LEVELS.Read,
  [GithubPermissions.Checks]: GITHUB_PERMISSIONS_LEVELS.Write,
  [GithubPermissions.Statuses]: GITHUB_PERMISSIONS_LEVELS.Write,
  [GithubPermissions.Contents]: GITHUB_PERMISSIONS_LEVELS.Read,
  [GithubPermissions.Deployments]: GITHUB_PERMISSIONS_LEVELS.Write,
  [GithubPermissions.Issues]: GITHUB_PERMISSIONS_LEVELS.Read,
  [GithubPermissions.Members]: GITHUB_PERMISSIONS_LEVELS.Read,
  [GithubPermissions.Metadata]: GITHUB_PERMISSIONS_LEVELS.Read,
  [GithubPermissions.PullRequests]: GITHUB_PERMISSIONS_LEVELS.Write,
  [GithubPermissions.Webhooks]: GITHUB_PERMISSIONS_LEVELS.Write,
};
